import { jsx } from 'react/jsx-runtime';
import { createContext } from 'react';
import { useInternalDynamicContext } from '../DynamicContext/useInternalDynamicContext.js';
import '@dynamic-labs/sdk-api';
import '../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import '../ViewContext/ViewContext.js';
import '@dynamic-labs/wallet-book';
import '@dynamic-labs/utils';
import '../../utils/constants/colors.js';
import '../../shared/utils/classes/storage/localStorage.js';
import 'ethers';
import '../../shared/consts/index.js';
import '@dynamic-labs/multi-wallet';
import '../ErrorContext/ErrorContext.js';
import '../../config/ApiEndpoint.js';
import '../AccessDeniedContext/AccessDeniedContext.js';
import '../AccountExistsContext/AccountExistsContext.js';
import '../CaptchaContext/CaptchaContext.js';
import { useSyncPrimaryWallet } from '../../utils/hooks/multiWallet/useSyncPrimaryWallet/useSyncPrimaryWallet.js';

const WalletContext = createContext(undefined);
const WalletContextProvider = ({ children, canSync, }) => {
    const { computeConnectedStateForWallets, handleLogOut, multiWalletWidgetState, primaryWallet, secondaryWallets, setMultiWalletWidgetState, setPrimaryWallet, setShowWidgetStatePopup, showWidgetStatePopup, authMode, connectWallet, } = useInternalDynamicContext();
    useSyncPrimaryWallet({
        authMode,
        canSync,
        computeConnectedStateForWallets,
        connectWallet,
        handleLogOut,
        multiWalletWidgetState,
        primaryWallet,
        secondaryWallets,
        setMultiWalletWidgetState,
        setPrimaryWallet,
        setShowWidgetStatePopup,
        showWidgetStatePopup,
    });
    const value = undefined;
    return (jsx(WalletContext.Provider, Object.assign({ value: value }, { children: children })));
};

export { WalletContext, WalletContextProvider };
